import React, { useState, useEffect } from 'react';
import { useTheme } from './ThemeContext';
import { Icons } from './icons';

function Recommendations({ dailyNorms, userProfile, onBack }) {
  const { colors } = useTheme();
  const [categories, setCategories] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('nutrition');
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRecommendations();
  }, []);

  const loadRecommendations = async () => {
    try {
      const response = await fetch('https://storage.yandexcloud.net/ai-nutrition-app/recommendations.json?t=' + Date.now());
      const data = await response.json();
      setCategories(data.categories || []);
      setRecommendations(data.recommendations || []);
      if (data.categories && data.categories.length > 0) {
        setSelectedCategory(data.categories[0].id);
      }
    } catch (error) {
      console.error('Ошибка загрузки рекомендаций:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredRecommendations = recommendations.filter(r => r.categoryId === selectedCategory);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const emojiToIcon = (icon, id, color) => {
    const map = {
      '🥗': <Icons.meal size={16} color={color} />,
      '🍎': <Icons.protein size={16} color={color} />,
      '🏃': <Icons.stats size={16} color={color} />,
      '💪': <Icons.profile size={16} color={color} />,
      '😴': <Icons.calories size={16} color={color} />,
      '💧': <Icons.carbs size={16} color={color} />,
      '🍽️': <Icons.perfectMeal size={16} color={color} />,
      '🍽': <Icons.perfectMeal size={16} color={color} />,
    };
    if (map[icon]) return map[icon];
    return <span style={{fontSize:16, fontWeight:700, color}}>{(id||'?')[0].toUpperCase()}</span>;
  };

  const s = useStyles(colors);

  if (loading) {
    return (
      <div style={s.page}>
        <div style={s.header}>
          <button style={s.backBtn} onClick={onBack}><Icons.back size={24} color="#fff" /></button>
          <div style={s.headerTitle}><Icons.recommendations size={18} color="#fff" /> Рекомендации</div>
          <div style={s.headerPlaceholder}></div>
        </div>
        <div style={s.loading}>Загрузка...</div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.header}>
        <button style={s.backBtn} onClick={onBack}><Icons.back size={24} color="#fff" /></button>
        <div style={s.headerTitle}><Icons.recommendations size={18} color="#fff" /> Рекомендации</div>
        <div style={s.headerPlaceholder}></div>
      </div>

      {/* Категории */}
      {categories.length > 0 && (
        <div style={s.categoriesWrapper}>
          <div style={s.categoriesScroll}>
            {categories.map(cat => (
              <button
                key={cat.id}
                style={{
                  ...s.categoryBtn,
                  background: selectedCategory === cat.id ? '#1D9E75' : colors.card,
                  color: selectedCategory === cat.id ? 'white' : colors.text
                }}
                onClick={() => setSelectedCategory(cat.id)}
              >
                <span style={s.categoryIcon}>{emojiToIcon(cat.icon, cat.id, selectedCategory === cat.id ? '#fff' : colors.text)}</span>
                <span style={s.categoryName}>{cat.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Список рекомендаций */}
      <div style={s.content}>
        {filteredRecommendations.length === 0 ? (
          <div style={s.empty}>Нет рекомендаций в этой категории</div>
        ) : (
          filteredRecommendations.map(rec => (
            <div key={rec.id} style={s.card} onClick={() => toggleExpand(rec.id)}>
              <div style={s.cardHeader}>
                <div style={s.cardTitle}>{rec.title}</div>
                <div style={s.cardArrow}>{expandedId === rec.id ? <Icons.arrowUp size={14} /> : <Icons.arrowDown size={14} />}</div>
              </div>
              {expandedId === rec.id && (
                <div style={s.cardContent}>{rec.content}</div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const useStyles = (colors) => ({
  page: {
    maxWidth: '420px',
    margin: '0 auto',
    minHeight: '100vh',
    background: colors.page,
    fontFamily: 'system-ui, -apple-system, sans-serif'
  },
  header: {
    background: colors.header,
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  backBtn: {
    background: 'none',
    border: 'none',
    color: '#fff',
    fontSize: '24px',
    cursor: 'pointer',
    padding: '0 8px'
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#fff'
  },
  headerPlaceholder: {
    width: '40px'
  },
  loading: {
    textAlign: 'center',
    padding: '40px',
    color: colors.textMuted
  },
  categoriesWrapper: {
    padding: '12px 0',
    borderBottom: `1px solid ${colors.border}`
  },
  categoriesScroll: {
    display: 'flex',
    gap: '8px',
    padding: '0 16px',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch'
  },
  categoryBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    borderRadius: '20px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    transition: 'all 0.2s',
    flexShrink: 0
  },
  categoryIcon: {
    fontSize: '16px'
  },
  categoryName: {
    fontSize: '13px'
  },
  content: {
    padding: '16px'
  },
  empty: {
    textAlign: 'center',
    padding: '40px',
    color: colors.textMuted
  },
  card: {
    background: colors.card,
    borderRadius: '16px',
    padding: '16px',
    marginBottom: '12px',
    cursor: 'pointer',
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
    transition: 'box-shadow 0.2s'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: colors.text,
    flex: 1,
    paddingRight: '12px',
    lineHeight: '1.4'
  },
  cardArrow: {
    fontSize: '14px',
    color: colors.textMuted
  },
  cardContent: {
    marginTop: '14px',
    paddingTop: '14px',
    borderTop: `1px solid ${colors.border}`,
    fontSize: '14px',
    color: colors.textLight,
    lineHeight: '1.5',
    whiteSpace: 'pre-line'
  }
});

export default Recommendations;